import { createContext } from 'react';

type ShowTooltipContextType = {
  showTooltip: (anchorEl: HTMLElement, content: React.ReactNode) => void;
};
export const ShowTooltipContext = createContext<ShowTooltipContextType>({
  showTooltip: () => {},
});

type HideTooltipContextType = {
  hideTooltip: () => void;
};
export const HideTooltipContext = createContext<HideTooltipContextType>({
  hideTooltip: () => {},
});
